import { createListener } from '@state/store/createListener';
import {
  filterTokens,
  resetFlightFilters,
  resetFlightFilterTokens,
  setSelectedFilters
} from '@state/slices/filters/filterSlice';

/* *************** *
 *   LISTENERS     *
 * *************** */
export const setupFiltersListeners = () => {
  createListener([resetFlightFilters], async (_action, listenerApi) => {
    listenerApi.dispatch(resetFlightFilterTokens());
  });
  createListener([setSelectedFilters], async (action, listenerApi) => {
    listenerApi.dispatch(filterTokens(action));
  });
};
